import { breakpoints } from "../../settings";
export var breakpointFromKeys = Object.keys(breakpoints);
export var breakpointToKeys = breakpointFromKeys.filter(function (breakpoint) {
  return !breakpoint.includes("small");
});
var breakpoint = function breakpoint(from, to) {
  return "@media (min-width: ".concat(breakpoints[from], "px)").concat(to ? " and (max-width: ".concat(breakpoints[to] - 0.02, "px)") : "");
};
export default breakpoint;